import './index.scss'
$(".section2 ul li .left .icon").hover(function() {
    $(this).parent().find(".model").css("opacity","1");
    $(this).parent().find(".pic").css("opacity","1");
})